import { jsxs as u, jsx as s } from "react/jsx-runtime";
import { forwardRef as C, useState as b, useEffect as h } from "react";
import r from "./styles.module.less.js";
const V = C(
  (n, g) => {
    var v, f;
    const { value: i, labels: c = [], min: t, max: o, onChange: x, disabled: N } = n, [l, d] = b(i), [m, p] = b(void 0);
    h(() => {
      if (l !== void 0)
        for (let a = 0; a < c.length; a++) {
          const e = c[a];
          if (e.lower && e.upper && l >= e.lower && l <= e.upper) {
            p(e.text);
            break;
          } else if (e.lower && !e.upper && l >= e.lower) {
            p(e.text);
            break;
          } else if (!e.lower && e.upper && l <= e.upper) {
            p(e.text);
            break;
          }
        }
    }, [l, c]);
    const w = (a) => {
      d(a), x(a);
    };
    return h(() => {
      d(i);
    }, [i]), /* @__PURE__ */ u("div", { className: r.scaleInputContainer, children: [
      /* @__PURE__ */ s(
        "input",
        {
          ref: g,
          ...n.props,
          className: `${r.scaleInput} ${((v = n.props) == null ? void 0 : v.className) || ""}`,
          type: "range",
          value: l === void 0 ? t : l,
          min: t,
          max: o,
          onChange: (a) => w(parseInt(a.target.value)),
          style: {
            ...(f = n.props) == null ? void 0 : f.style,
            ...l ? {
              "--percentage": l === void 0 ? 0 : ((l || 0) - t) / (o - t) * 100 + "%"
            } : {}
          },
          disabled: N
        }
      ),
      /* @__PURE__ */ u("div", { className: r.scaleInputLabels, children: [
        /* @__PURE__ */ s("div", { children: t }),
        /* @__PURE__ */ u("div", { className: r.labelWrapper, children: [
          /* @__PURE__ */ s("div", { className: r.currentValue, children: l }),
          m ? /* @__PURE__ */ s("div", { className: r.label, children: m }) : null
        ] }),
        /* @__PURE__ */ s("div", { children: o })
      ] })
    ] });
  }
);
export {
  V as ScaleInput
};
